import React, { useEffect, useState } from "react";
import { clientSettingsConfig } from "../../../../../redux/slices/careersSlices.reducer";
import useClientConfig from "../../../../../config/careers/clientConfig";
import { useSelector } from "react-redux";

const ZfBanner = () => {
    const [bannerCount, setBannerCount] = useState(0);
    const { clientSiteSettings } = useClientConfig();
    const cliendConfig = useSelector((state: any) => state.careers.cliendConfig);

    useEffect(() => {
        let interval: any;
        let total_number_of_banners = clientSiteSettings?.bannerData?.length > 0 ? clientSiteSettings?.bannerData?.length : 0;
        //Implementing the setInterval method
        if (bannerCount <= total_number_of_banners - 1) {
            interval = setInterval(() => {
                setBannerCount((bannerCount) => bannerCount + 1);
            }, 5000);
        } else {
            clearInterval(interval);
            setBannerCount(0);
        }

        //Clearing the interval
        return () => clearInterval(interval);
    }, [bannerCount]);
    return (
        <div className="default-option-new-theme-banner micro_banner">
            <div className="page-title-content">
                <div className="animate-text">
                    <div className="slider-items">
                        {
                            clientSiteSettings?.bannerData?.map((banner: any, index: number) => {
                                return (
                                    <div key={index} className={`slide-item ${bannerCount === index ? "active" : ""}`} data-count={`slide-${index}`}>
                                        <img src={cliendConfig?.data?.data?.clientSettings?.assetsLink + "/" + banner?.imgUrl} alt={cliendConfig?.assetsLink + "/" + banner?.imgUrl} />
                                    </div>
                                );
                            })
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ZfBanner;